export default "__VITE_ASSET__d6ffd0b3__"